var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgBell(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "#FFF",
    d: "M7.092 5.043a5.002 5.002 0 019.83.076 3 3 0 012.113 2.348l2.629 13.558a1 1 0 01-.806 1.162A50.712 50.712 0 0111.84 23c-3.006 0-6.012-.271-9.017-.813a1 1 0 01-.807-1.162L4.645 7.467a3 3 0 012.447-2.424zM11.84 21c2.558 0 5.117-.204 7.676-.614L17.067 7.822A1 1 0 0016.083 7H7.597a1 1 0 00-.984.822l-2.45 12.564c2.56.41 5.12.614 7.677.614zM12 3a3.001 3.001 0 00-2.83 2h5.66A3.001 3.001 0 0012 3zm-2.986 7.836a1 1 0 111.972.328l-1 6a1 1 0 11-1.972-.328l1-6z"
  }));
}

export default SvgBell;